<template>
  <div class="col-span-full container z-grid v-page-section-container-padding">
    <MoleculeShelf :title="label" :button-url="buttonUrl" :button-title="buttonTitle" class="col-span-full 2xl:col-start-2 2xl:col-end-12">
      <div class="grid grid-cols-12 gap-4 sm:gap-5 lg:gap-8">
        <MoleculeCardCollection
          v-for="(entry, index) in entries.slice(0, 4)"
          :key="index"
          class="col-span-6"
          :title="entry.title"
          :image="entry.image"
          :url="entry.url"
          :button-text="$t('discovery-shelf-collection-label')"
        />
      </div>
    </MoleculeShelf>
  </div>
</template>

<script setup lang="ts">
defineProps({
  label: { type: String, required: true },
  entries: { type: Array as PropType<any[]>, required: true },
  buttonTitle: { type: String, required: false, default: undefined },
  buttonUrl: { type: String, required: false, default: undefined },
})
</script>
